import React, { useContext, useEffect, useState, useRef } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Attach from "../../assets/img/attach.png";
import More from "../../assets/img/more.png";
import Smile from "../../assets/img/smile.png";
import logo from "../../assets/img/logo.png";
import Close from "../../assets/img/close.png";
import Send from "../../assets/img/send1.svg";
import Mic from "../../assets/img/mic.svg";
import Asc from "../../assets/img/desc.svg";
import Desc from "../../assets/img/asc.svg";
import Whatsapp from "../../assets/img/whatsapp.svg";
import fileDownload from "../../assets/img/filedownload.svg";
import Sync from "../../assets/img/sync.svg";
import singleTick from "../../assets/img/singleTick.svg";
import doubleTick from "../../assets/img/doubleTick.svg";
import blueTick from "../../assets/img/blueTick.svg";
import addNotification from 'react-push-notification';
import { SpinnerCircular } from "spinners-react";

import "../../assets/scss/style.scss";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { Badge } from "reactstrap";
import axios from "axios";
import { format, render, cancel, register } from "timeago.js";
import InputEmoji from "react-input-emoji";
import io from "socket.io-client";
import { stringify } from "postcss";
import moment from "moment";
import EmojiPicker from "emoji-picker-react";
import {
  BASE_URL_CHAT_APP,
  BASE_URL_CHAT_WHATSAPP,
  SOCKET_URL,
  AGENT_TRANSFER,
  SYNC_CHAT

} from "../../constants.js";
import NotificationSound from "../../assets/audio/notification-sound.mp3";
import LoadingScreen from "react-loading-screen";

let loginmenus = localStorage.getItem("menus");
let menus = JSON.parse(loginmenus);

const menuexist = menus?.filter(item=>item.name=="agent")
var socket;
if(menuexist?.length!=0){
  
  socket = io.connect(SOCKET_URL)
}


let imgurl = "";

function Chat() {
  
  const [text, setText] = useState("");
  const [img, setImg] = useState(null);
  const myref = useRef();
  const [isemojiShow, setIsEmojiShow] = useState(false);
  const [count, setCount] = React.useState(0);
  const [search, setSearch] = useState([]);
  const [usermsg, setUsermessage] = useState([]);
  const [client, setClient] = useState({
    displayName: "",
    pic: "",
  });
  const [isDesc, setIsDesc] = useState(true);
  const [rec, setRec] = useState({ msisdn: "", name: "", message: "" });
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const [users, setUser] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  let loginUser = localStorage.getItem("user");
  let luser = JSON.parse(loginUser);

  const [alert, setAlert] = React.useState(null);



  useEffect(() => {
    UserObject("initialRender");
  }, []);

  // useEffect(() => {
  //   setText(transcript);
  // }, [transcript]);
  useEffect(() => {
    let loginUser = localStorage.getItem("user");
    let luser = JSON.parse(loginUser);
    socket.on("recieveUserList_" + luser?.user_id, (data) => {
      //  let c = JSON.parse(data);
      console.log("---94--",data);
     // let c = data;
      UserObject(data);
    });
  }, [socket]);

  useEffect(() => {
    let loginUser = localStorage.getItem("user");
    let luser = JSON.parse(loginUser);
    socket.on("recieveUserMsg_" + luser?.user_id, (data) => {
  
      const sound = new Audio(NotificationSound)?.play();
      let c = data;
      setRec(c);
      let a = c.message + "@time" + c.time;
      sendNotification(c.message);
      handleSend(a, c.msisdn, "to");
    });
  }, [socket]);

 //Scroll Chat When New Message came
 useEffect(() => {
  myref.current?.scrollIntoView();
}, [count]);

  // Status Change
  useEffect(() => {
    let loginUser = localStorage.getItem("user");
    let luser = JSON.parse(loginUser);
    socket.on("recieveStatus_" + luser?.user_id, (data) => {
      console.log("--status--",data);
      changeStatus(data);
    });
  }, [socket]);

  let mobileNum = client.msisdn;

  const localdata = localStorage.getItem(mobileNum);
  var userMessages = [];

  if (localdata) {
    let msg = JSON.parse(localdata);
    userMessages = [
      {
        name: client.displayName,
        msisdn: client.msisdn,
        msg,
      },
    ];
  }

 

  const textHandle = (event) => {
    setText(event.target.value);
  };

  // Send Message Api
  const sendMessage = async (msg, msisdn) => {
    setFileLoading(true);
    let formatType = "text";
    let auth =
      "Bearer EAAOIFpeesZB8BOzCaRD4mKk40ySBObFTBH7ZANeHlC9zvzN8ULk9umfZAaZAmpxbJZCFqz7ZAvcb7qrHcrXAxOQZA3Raz5FtXrqqRYoRyzGR1ZB4hGcCDbg1urZBefhvxH1ZBn8sKtYs72prWl1MAXtjdGMmBEuKxZAY54eEhrLxPcjfxIhssBCNYxFhwK3NAy5";

    let userObj = localStorage.getItem("user");
    let user = JSON.parse(userObj);
    let payload = {};

    if (msg.split("^")[0] == "urlfromchat") {
      let fileType = msg.split("^")[1];
      let videoFile = fileType.includes(".mp4");
      let document =
        fileType.includes(".xlsx") ||
        fileType.includes(".pdf") ||
        fileType.includes(".txt");
      if (videoFile) {
        payload = {
          method: "POST",
          body: JSON.stringify({
            messaging_product: "whatsapp",
            preview_url: false,
            recipient_type: "individual",
            to: msisdn,
            type: "video",
            sender_id: user.sender_id,
            user_id: user.user_id,
            video: {
              link: msg.split("^")[1],
            },
          }),

          // Adding headers to the request
          headers: {
            Authorization: auth,
            "Content-Type": "application/json",
          },
        };
      } else if (document) {
        payload = {
          method: "POST",
          body: JSON.stringify({
            messaging_product: "whatsapp",
            preview_url: false,
            recipient_type: "individual",
            to: msisdn,
            type: "document",
            sender_id: user.sender_id,
            user_id: user.user_id,
            document: {
              link: msg.split("^")[1],
            },
          }),

          // Adding headers to the request
          headers: {
            Authorization: auth,
            "Content-Type": "application/json",
          },
        };
      } else {
        payload = {
          method: "POST",
          body: JSON.stringify({
            messaging_product: "whatsapp",
            preview_url: false,
            recipient_type: "individual",
            to: msisdn,
            type: formatType,
            sender_id: user.sender_id,
            user_id: user.user_id,
            type: "image",
            image: {
              link: msg.split("^")[1],
            },
          }),

          // Adding headers to the request
          headers: {
            Authorization: auth,
            "Content-Type": "application/json",
          },
        };
      }
    } else {
      payload = {
        method: "POST",
        body: JSON.stringify({
          messaging_product: "whatsapp",
          preview_url: false,
          recipient_type: "individual",
          to: msisdn,
          type: formatType,
          sender_id: user.sender_id,
          user_id: user.user_id,
          text: {
            body: msg,
          },
        }),

        // Adding headers to the request
        headers: {
          Authorization: auth,
          "Content-Type": "application/json",
        },
      };
    }

    let obj = await fetch(BASE_URL_CHAT_APP + "/graphapi", payload)
      .then((res) => res.json())
      .then((e) => {
        //console.log("--237--",e);
        return e;
      })
      .catch((err) => {});
    setFileLoading(false);
    return obj?.id;
  };

  const UserObject = (data) => {
    if (data === "initialRender") {
      let usrobjlocl = localStorage.getItem("userObj");
      if (usrobjlocl) {
        let usrArray = JSON.parse(usrobjlocl);
        setUser(usrArray);
        setSearch(usrArray);
      }
    } else {
      let usrobjlocl = localStorage.getItem("userObj");
      if (usrobjlocl) {
        let lclArr = [];
        let usrArr = JSON.parse(usrobjlocl);
        usrArr.map((item) => lclArr.push(item));
        Array.isArray(data)
          ? data.map((item) => lclArr.push(item))
          : lclArr.push(data);
        localStorage.removeItem("userObj");
        const ids = lclArr.map(({ msisdn }) => msisdn);
        const filtered = lclArr.filter(
          ({ msisdn }, index) => !ids.includes(msisdn, index + 1)
        );
        localStorage.setItem("userObj", JSON.stringify(filtered));
      } else {
        localStorage.setItem("userObj", JSON.stringify(data));
      }
      let c = localStorage.getItem("userObj");
      let cc = JSON.parse(c);

      setUser(cc);
      setSearch(cc);
    }
  };

  // Saving Message to Localstorage
  const handleSend = async (msg, msisdn, data) => {
    if (msg.trim() != "") {
      setCount(count + 1);
      let userName = msisdn;
      let add = "";

      if (msg) {
        let currentDt = moment(new Date()).format("YYYY-MM-DD hh:mm a");
        //message from web
        if (data === "from") {
          const obj = await sendMessage(msg, msisdn);
          add = [
            {
              from: msg.trim() + "@time" + currentDt,
              id: obj,
              status: "sent",
            },
          ];
          // add = [{ from: msg.trim() + "@time" + currentDt }];
          // sendMessage(msg, msisdn);
        } else {
          //message from whatsapp
          add = [{ to: msg.trim() }];
        }

        let lsa = [];
        let ls = localStorage.getItem(userName);
        
        let c = JSON.parse(ls);
        if (c&&c.length>0) {
          
          if (c.length > 15) {
            c.shift();
          }
          if (data === "to") {
            c.map((item) => {
              lsa.push(item);
            });

            if (lsa[lsa.length - 1].to != add[0].to) {
              lsa.push(add[0]);
            }
          } else {
            c.map((item) => {
              lsa.push(item);
            });
            lsa.push(add[0]);
          }
          localStorage.setItem(`${userName}`, JSON.stringify(lsa));
        } else {
          localStorage.setItem(`${userName}`, JSON.stringify(add));
        }
      }
      if (data === "from") {
        setText(" ");
      }

      setImg(null);
      setIsEmojiShow(false);
    }
  };

  const warningWithConfirmMessage1 = () => {
    let msisdn = client.msisdn;
    localStorage.removeItem(msisdn);
    let cc = localStorage.getItem("userObj");
    let d = JSON.parse(cc);
    let c = d.filter((item) => item.msisdn != msisdn);
    localStorage.removeItem("userObj");
    localStorage.setItem("userObj", JSON.stringify(c));
    let dd = localStorage.getItem("userObj");
    let dde = JSON.parse(dd);
    setUser(dde);
    setSearch(dde);
    setClient({ displayName: "", image: "" });
  };

  // Tranfer user to another agent
  const assaignAgent = async() => {
    let payload ={
      senderid:luser.sender_id,
      agenttype:luser.agenttype,
      agentid:luser.user_id,
      userid:client.msisdn
    }
    await axios.post(AGENT_TRANSFER,payload).then(res=>{

      if(res.status===200){
        if(res?.data?.isassigned===0){
         
        let usrobjlocl = localStorage.getItem("userObj");
        if (usrobjlocl) {
          let lclArr = [];
          let usrArr = JSON.parse(usrobjlocl);
          usrArr.map((item) => {
          
            if(item.msisdn!=client.msisdn){
              lclArr.push(item)
            }
           
          })
          localStorage.removeItem("userObj");
          localStorage.removeItem(client.msisdn)
          
          localStorage.setItem("userObj", JSON.stringify(lclArr));
          let c = localStorage.getItem("userObj");
          let cc = JSON.parse(c);
          setUser(cc);
          setSearch(cc);
          setClient({
            displayName: "",
            pic: "",
          }
          )
        }
          setAlert(
            <ReactBSAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Assigned"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="success"
              btnSize=""
            >
              {res?.data?.message}
            </ReactBSAlert>
          );
        }else{
          setAlert(
            <ReactBSAlert
            danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Not Assigned!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="success"
              btnSize=""
            >
               {res?.data?.message}
            </ReactBSAlert>
          );

        }
    
      }
    })

  };

  const hideAlert = () => {
    setAlert(null);
  };

  const sendNotification=(message)=>{
    addNotification({
      title: 'Agent Notification',
      subtitle: 'This is a subtitle',
      message: message,
      theme: 'darkblue',
      native: true // when using native, your OS will handle theming.
  });
  }

  const firebaseNotification=async()=>{
    
    addNotification({
      title: 'Agent Notification',
      subtitle: 'This is a subtitle',
      message: 'This is a very long message',
      theme: 'darkblue',
      native: true // when using native, your OS will handle theming.
  });
    const firebaseToken=localStorage.getItem("firebase");
    let auth="key=AAAAYBBDz5E:APA91bGPW2urX89He6bTH1PxYOx98SbG1dKMvhIT4AwiGxqmsv9voPFkXMgzyotJVazEaGOXBavMGKl713B3j9ugen2J_rjtBa9bN6xXDivaYR1ajaOYn0CSf-Q2MbFvIMGPH5dI3D9o";
    let payload={
     
     
        to:firebaseToken,
        notification:{
             body:"testtt",
             title:"okay"
           }
      
     
   }
    await axios.post('https://fcm.googleapis.com/fcm/send',payload,{ headers: {
      Authorization: auth
    }}).then(res=>console.log(res.data.data))
  }
  const transferLevel = () => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => assaignAgent()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Assign"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You are Assigned User to Next Level Agent.
      </ReactBSAlert>
    );
  };

  const searchUser = (name) => {
    let suser = search.filter((item) =>
      item.name.toLowerCase().includes(name.toLowerCase())
    );
    setUser(suser);
  };

  const searchMessage = (message, uname) => {};

  const uploadImg = (file, msisdn) => {
    setFileLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        setImg(response?.data?.Response);
        let imgUrl = "urlfromchat^" + response?.data?.Response;
       
        handleSend(imgUrl, msisdn, "from");
      })
      .catch((err) => console.log("err==>", err));
  };

  //Change Status of Message
  const changeStatus = (data) => {
    let userName = data.msisdn;
    let id = data.id;
    let lsa = [];
    let ls = localStorage.getItem(userName);
    if (ls) {
      let messages = JSON.parse(ls);
      messages.map((item) => {
        if (item?.id == id) {
          lsa.push({
            from: item?.from,
            id: item?.id,
            status: data.status,
          });
        } else {
          lsa.push(item);
        }
      });
    }

    localStorage.setItem(`${userName}`, JSON.stringify(lsa));

    const lsMsgs = localStorage.getItem(userName);

    if (lsMsgs) {
      let msgs = JSON.parse(lsMsgs);
      userMessages = [
        {
          name: client.displayName,
          msisdn: client.msisdn,
          msgs,
        },
      ];
    }
    setUsermessage(userMessages);
  };

  const syncMessages=async()=>{
    setSyncLoading(true)
    console.log();
    let payload = {
      agent_id:luser.user_id.toString(),
      msisdn:client.msisdn
    }
    await axios.post(SYNC_CHAT,payload).then(res=>{
      let synrecords = []
      res?.data?.message?.map(item=>{
        if(item?.from_msg===1){
          let msgStatus = "";
          switch (item.status) {
            case 5:
              msgStatus = "delivered";
              break;
            case 6:
              msgStatus = "sent";
              break;
            case 13:
              msgStatus = "read";
              break;
           
          }
          if(item?.message_body.includes(BASE_URL_CHAT_WHATSAPP+"/files/")){
            synrecords.push({
              from:"urlfromchat^"+item?.message_body+"@time"+item?.time,
              status:msgStatus,
              id:item.id
            })
          }else{
          synrecords.push({
            from:item?.message_body+"@time"+item?.time,
            status:msgStatus,
            id:item.id
          })
        }
      }else{
        synrecords.push({
          to:item?.message_body+"@time"+item?.time
        })
      }
      })
      if(synrecords.length>0){
        
      localStorage.removeItem(client.msisdn)
      localStorage.setItem(client.msisdn, JSON.stringify(synrecords.reverse()));
      }
    
    })
      setSyncLoading(false)
  }

 

  return (
    <>{alert}
      <div className="home">
        <div className="containerChat">
          <div className="sidebarChat">
            <div className="navbarChat">
              <span className="logo" >Live Chat</span>
            </div>
            <div className="searchUser">
              <input
                type="text"
                placeholder="search user..."
                onChange={(e) => searchUser(e.target.value)}
              />
              <label
                onClick={() => {
                  setIsDesc(!isDesc);
                }}
                style={{ width: "23px" }}
              >
                <img src={isDesc ? Asc : Desc} alt="" />
              </label>
            </div>
            <div className="chats">
              {users?.length > 0 ? (
                [...users]
                  ?.sort((a, b) =>
                    isDesc
                      ? a?.name?.localeCompare(b?.name)
                      : b?.name?.localeCompare(a?.name)
                  )
                  .map((user, i) => {
                  
                    console.log("2----",user.msisdn);
                    let lclstrg = localStorage.getItem(user.msisdn);
                    let lcljsn = JSON.parse(lclstrg);
                    let a = lcljsn?.length - 1;
                      console.log("1----",lcljsn);
                    return (
                      <React.Fragment key={i}>
                        <div
                          className={"userChats"}
                          style={{
                            backgroundColor:
                              user.name == client.displayName && "#e9e9e9ed",
                          }}
                        >
                          <div
                            onClick={() => {
                              setClient({
                                pic: user.image,
                                displayName: user.name,
                                msisdn: user.msisdn,
                              });

                              setText("");
                              setIsEmojiShow(false);

                              setCount(count + 1);
                            }}
                            className={"userChat"}
                          >
                            <div className="NameImg">
                              <span
                                style={{
                                  justifyContent: "center",
                                  fontSize: "35px",
                                  padding: "10px",
                                  marginLeft: "5px",
                                }}
                              >
                                {user?.name?.charAt(0).toUpperCase()}
                              </span>
                            </div>

                            <img
                              src={Whatsapp}
                              alt=""
                              style={{
                                width: "20px",
                                height: "20px",
                                marginLeft: "-16px",
                                marginTop: "26px",
                              }}
                            />
                            <div className="userChatInfo">
                              {/* Selected User */}
                              {user?.msisdn == rec?.msisdn ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>{user?.name}</span>
                                    
                                    <span style={{ fontSize: "10px" }}>
                                    
                                      {lcljsn&&lcljsn[a]?.to && (
                                        <p>
                                          {format(
                                            lcljsn[a]?.to.split("@time")[1]
                                          )}
                                        </p>
                                      )}
                                      {lcljsn&&lcljsn[a]?.from && (
                                        <p>
                                          {format(
                                            lcljsn[a]?.from.split("@time")[1]
                                          )}
                                        </p>
                                      )}
                                    </span>
                                  </div>

                                  {lcljsn&&Object?.keys(lcljsn[a])[0] == "from" && (
                                      <>
                                        {
                                          <p>
                                            {lcljsn[a]?.from
                                              ?.split("@time")[0]
                                              .includes("/files/") ? (
                                              <>
                                                {" "}
                                                <img
                                                  src={fileDownload}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                />
                                                <span>File</span>
                                              </>
                                            ) : (
                                              lcljsn[a]?.from?.split("@time")[0]
                                            )}
                                          </p>
                                        }
                                      </>
                                    )}
                                  {lcljsn&&Object?.keys(lcljsn[a]) == "to" && (
                                      <>
                                        <span
                                          style={{
                                            content: " ",
                                            position: "absolute",
                                            height: "6px",
                                            width: "6px",
                                            background: "red",
                                            borderRadius: "50%",
                                            marginTop: "-30px",
                                            marginLeft: "-30px",
                                          }}
                                        ></span>
                                        <p>
                                          {lcljsn[a]?.to
                                            ?.split("@time")[0]
                                            .includes("/files/") ? (
                                            <>
                                              {" "}
                                              <img
                                                src={fileDownload}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                              <span>File</span>
                                            </>
                                          ) : (
                                            lcljsn[a]?.to?.split("@time")[0]
                                          )}
                                        </p>
                                      </>
                                    )}
                                </>
                              ) : (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                      
                                    <span>{user?.name}</span>
                                 
                                    <span style={{ fontSize: "10px" }}></span>
                                    {(lcljsn&&lcljsn.length>0)&&(
                                      <span style={{ fontSize: "10px" }}>
                                        
                                        {lcljsn[a]?.to?.split("@time")[1] && (
                                          <p>
                                            {format(
                                              lcljsn[a]?.to.split("@time")[1]
                                            )}
                                          </p>
                                        )}
                                        {lcljsn[a]?.from?.split("@time")[1] && (
                                          <p>
                                            {format(
                                              lcljsn[a]?.from.split("@time")[1]
                                            )}
                                          </p>
                                        )}
                                      </span>
                                    )}
                                  </div>

                                  {(lcljsn&&lcljsn.length>0)&&Object?.keys(lcljsn[a]) == "to" && (
                                      <>
                                        <span
                                          style={{
                                            content: " ",
                                            position: "absolute",
                                            height: "6px",
                                            width: "6px",
                                            background: "red",
                                            borderRadius: "50%",
                                            marginTop: "-30px",
                                            marginLeft: "-30px",
                                          }}
                                        ></span>
                                        <p>
                                          {(lcljsn&&lcljsn.length>0)&&lcljsn[a]?.to?.split("@time")[0]}
                                        </p>
                                      </>
                                    )}

                                  {(lcljsn&&lcljsn.length>0)&&Object?.keys(lcljsn[a])[0] == "from" && (
                                      <>
                                        {
                                          <p>
                                            {/* {lcljsn[a]?.from.split("@time")[0]} */}
                                            {lcljsn[a]?.from
                                              ?.split("@time")[0]
                                              .includes("/files/") ? (
                                              <>
                                                {" "}
                                                <img
                                                  src={fileDownload}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                />
                                                <span>File</span>
                                              </>
                                            ) : (
                                              lcljsn[a]?.from?.split("@time")[0]
                                            )}
                                          </p>
                                        }
                                      </>
                                    )}
                                </>
                              )}
                            </div>
                          </div>
                          {client.msisdn == user.msisdn && (
                            <div className="removeUser">
                              <img
                                src={Close}
                                alt=""
                                //  onClick={() => warningWithConfirmMessage()}
                              />
                            </div>
                          )}
                        </div>
                      </React.Fragment>
                    );
                  })
              ) : (
                <div>
                  <span style={{ margin: "30px" }}> User Not Found </span>
                </div>
              )}
            </div>
          </div>
          {client?.msisdn ? (
            <div className="chat">
              <div className="chatInfo">
                {client?.msisdn && (
                  <div style={{ display: "flex" }}>
                    <div style={{ marginTop: "5px" }}>
                      <span
                        style={{
                          padding: "5px 13px",
                          background: "#3dcfcf",
                          borderRadius: "50px",
                          fontSize: "18px",
                          color: "black",
                        }}
                      >
                        {client?.displayName?.charAt(0).toUpperCase()}
                      </span>
                      <img
                        src={Whatsapp}
                        alt=""
                        style={{
                          width: "20px",
                          height: "20px",
                          marginLeft: "-16px",
                          marginTop: "26px",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        color: "#000000",
                        marginLeft: "10px",
                        marginTop: "10px",
                      }}
                    >
                      <span style={{ fontStyle: "bold" }}>
                        {client?.displayName}
                      </span>
                      <div>
                      <span style={{ fontStyle: "bold" }}>
                        {client?.msisdn}
                      </span>
                      </div>
                    </div>
                    <p style={{ fontSize: "10px", margin: "15px" }}>
                      <Badge color="danger">Urgent</Badge>
                      <Badge color="info">Shipping</Badge>
                    </p>
                  </div>
                )}

                {client?.msisdn && (
                  <div className="chatIcons">
                    <img
                      src={Sync}
                      alt=""
                      onClick={() => {
                        syncMessages();
                      }}
                    />
                    <Badge
                      style={{ cursor: "pointer" }}
                      color="warning"
                     // onClick={() => transferLevel()}
                    >
                      {luser?.agenttype === "level1"
                        ? "L2"
                        : luser?.agenttype === "level2"
                        ? "L3"
                        : ""}
                    </Badge>
                    {/* <input
                type="text"
                placeholder="search user"
                onChange={(e) => searchMessage(e.target.value,client.displayName)}
              /> */}
                    <img src={More} alt="" />
                  </div>
                )}
              </div>
              {/* {syncLoading && (
                  <div
                    style={{
                      float: "right",
                      background: "lightgray",
                      padding: "25px",
                      height: "80px",
                      width: "180px",
                    }}
                  >
                    <a
                      style={{
                        width: "200px",
                        height: "800px",
                        backgroundColor: "lightgray",
                      }}
                    >
                      <span>uploading..</span>
                      <SpinnerCircular enabled={fileLoading} size={30} />
                    </a>
                  </div>
                )} */}
                  <LoadingScreen
          children=""
          loading={syncLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
              <div className="messages">
                {userMessages?.map(
                  (item, i) =>
                    item?.msisdn == client?.msisdn &&
                    item?.msg.map((msg, i) => {
                      return (
                        <React.Fragment key={i}>
                          {msg.from ? (
                            <div ref={myref} key={i} className="message owner">
                              {moment(msg?.to?.split("@time")[1]).format(
                                "YYYY-m-d hh:mm a"
                              ) < new Date("YYYY-m-d") && (
                                <span>
                                  {moment(msg?.to?.split("@time")[1]).format(
                                    "YYYY-m-d"
                                  )}
                                </span>
                              )}
                              <div className="messageInfo"></div>

                              <div className="messageContent">
                                {msg.from.split("^")[0] == "urlfromchat" &&
                                (msg.from.split("^")[1].includes([".png"]) ||
                                  msg.from.split("^")[1].includes([".jpeg"]) ||
                                  msg.from.split("^")[1].includes([".jpg"])) ? (
                                  <div
                                    style={{
                                      backgroundColor: "#e9e0e0",
                                      borderRadius: "9px 8px 0px 12px",
                                      width:"120px"
                                    }}
                                  >
                                    <div>
                                      <a
                                        href={
                                          msg.from
                                            .split("^")[1]
                                            .split("@time")[0]
                                        }
                                        target="_blank"
                                      >
                                        <img
                                          src={
                                            msg.from
                                              .split("^")[1]
                                              .split("@time")[0]
                                          }
                                          style={{
                                            width: "100%",
                                            height: "120px",

                                            objectFit: "cover",
                                          }}
                                        />
                                      </a>
                                    </div>
                                    <div style={{ marginLeft: "20%" }}>
                                      {" "}
                                      {moment(
                                        msg?.from.split("^")[1].split("@time")[1]
                                      ).format("hh:mm a")}
                                      {msg?.status == "sent" ? (
                                        <img
                                          src={singleTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : msg?.status?.toLowerCase() ==
                                        "delivered".toLocaleLowerCase() ? (
                                        <img
                                          src={doubleTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : msg?.status?.toLowerCase() ==
                                        "read".toLocaleLowerCase() ? (
                                        <img
                                          src={blueTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                ) : msg.from.split("^")[0] == "urlfromchat" ? (
                                  <a
                                    href={
                                      msg.from.split("^")[1].split("@time")[0]
                                    }
                                    target="_blank"
                                    style={{
                                      width: "100%",
                                      height: "110px",
                                      backgroundColor: "white",
                                      borderRadius: "9px 8px 0px 12px",
                                    }}
                                  >
                                    <img
                                      src={fileDownload}
                                      style={{
                                        width: "100px",
                                        height: "80px",
                                        paddingTop: "12px",
                                        paddingLeft: "50px",
                                      }}
                                    />
                                    <div style={{width:"109%",display:"flex",justifyContent:"space-between"}}>
                                      <span style={{ marginLeft: "5px" }}>
                                        ...
                                        {msg.from
                                          .split("@time")[0]
                                          .split("/files/")[1]
                                          .substr(-9, 9)}
                                      </span>
                                      <span
                                        style={{
                                          float: "right",
                                          color: "black",
                                          marginRight: "16px",
                                        }}
                                      >
                                        {moment(
                                          msg?.from?.split("@time")[1]
                                        ).format("MMM DD h:mm a")}
                                        {msg?.status == "sent" ? (
                                          <img
                                            src={singleTick}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                          />
                                        ) : msg?.status?.toLowerCase() ==
                                          "delivered".toLocaleLowerCase() ? (
                                          <img
                                            src={doubleTick}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                          />
                                        ) : msg?.status?.toLowerCase() ==
                                          "read".toLocaleLowerCase() ? (
                                          <img
                                            src={blueTick}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                            }}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </span>
                                    </div>
                                  </a>
                                ) : (
                                  <p>
                                    {msg.from.split("@time")[0]}
                                    <sub
                                      style={{
                                        marginLeft: "10px",
                                        marginTop: "50px",
                                        fontSize: "10px",
                                        color: "#e3e3e3",
                                      }}
                                    >
                                      {moment(
                                        msg.from.split("@time")[1]
                                      ).format("MMM DD hh:mm a")}
                                      {msg?.status == "sent" ? (
                                        <img
                                          src={singleTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : msg?.status?.toLowerCase() ==
                                        "delivered".toLocaleLowerCase() ? (
                                        <img
                                          src={doubleTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : msg?.status?.toLowerCase() ==
                                        "read".toLocaleLowerCase() ? (
                                        <img
                                          src={blueTick}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </sub>
                                  </p>
                                )}
                              </div>
                            </div>
                          ) : (
                            // Messages from Whatsapp
                            <div ref={myref} key={i} className="message ">
                              <div className="messageInfo">
                                {/* <span>just now</span> */}
                              </div>
                              <div className="messageContent">
                                {msg?.to?.includes("/files/") &&
                                msg?.to?.includes("https://") ? (
                                  msg?.to?.includes(".jpeg") ||
                                  msg?.to?.includes(".png") ||
                                  msg?.to?.includes(".jpg") ? (
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        padding: "2%",
                                        borderRadius: "9px 8px 12px 0px",
                                      }}
                                    >
                                      <div>
                                        <a
                                          href={msg.to.split("@time")[0]}
                                          target="_blank"
                                        >
                                          <img
                                            src={msg.to.split("@time")[0]}
                                            style={{
                                              width: "200px",
                                              height: "130px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        </a>
                                      </div>
                                      <div
                                        style={{
                                          float: "right",
                                          margin: "2px",
                                        }}
                                      >
                                        {msg.to.split("@time")[1] !=
                                          "undefined" &&
                                          moment(
                                            msg.to.split("@time")[1]
                                          ).format("MMM DD h:mm a")}
                                      </div>
                                    </div>
                                  ) : (
                                    <a
                                      href={msg.to.split("@time")[0]}
                                      target="_blank"
                                      style={{
                                        width: "100%",
                                        height: "110px",
                                        backgroundColor: "white",
                                        borderRadius: "9px 8px 0px 0px",
                                      }}
                                    >
                                      <img
                                        src={fileDownload}
                                        style={{
                                          width: "100px",
                                          height: "80px",
                                          paddingTop: "12px",
                                          paddingLeft: "50px",
                                        }}
                                      />
                                      <div>
                                        <span style={{ marginLeft: "5px" }}>
                                          ...
                                          {msg?.to
                                            ?.split("@time")[0]
                                            .split("/files/")[1]
                                            .substr(-9, 9)}
                                        </span>
                                        <span
                                          style={{
                                            float: "right",
                                            color: "black",
                                            marginRight: "16px",
                                          }}
                                        >
                                          {moment(
                                            msg.to.split("@time")[1]
                                          ).format("MMM DD h:mm a")}
                                        </span>
                                      </div>
                                    </a>
                                  )
                                ) : (
                                  <p>
                                    {msg.to.split("@time")[0]}
                                    <sub
                                      style={{
                                        paddingLeft: "10px",
                                        marginTop: "50px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {msg.to.split("@time")[1] !=
                                        "undefined" &&(
                                          
                                        moment(msg.to.split("@time")[1]).format(
                                          "MMM DD h:mm a"
                                        ))}
                                    </sub>
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })
                )}
                {fileLoading && (
                  <div
                    style={{
                      float: "right",
                      background: "lightgray",
                      padding: "25px",
                      height: "80px",
                      width: "180px",
                    }}
                  >
                    <a
                      style={{
                        width: "200px",
                        height: "800px",
                        backgroundColor: "lightgray",
                      }}
                    >
                      <span>uploading..</span>
                      <SpinnerCircular enabled={fileLoading} size={30} />
                    </a>
                  </div>
                )}
                {isemojiShow && (
                  <div
                    style={{
                      position:"absolute",
                      bottom:"11%"
                    }}
                    onClick={() => setCount(count + 1)}
                  >
                    {/* <Picker
                      data={data}
                      previewPosition="none"
                      // onClickOutside={()=>setIsEmojiShow(false)}
                      onEmojiSelect={(event) =>
                        setText((prevInput) => prevInput + event.native)
                      }
                    /> */}
                    <EmojiPicker
                    searchDisabled={true}
                      onEmojiClick={(emojiData) =>
                        setText((prevInput) => prevInput + emojiData.emoji)
                      }
                    />
                  </div>
                )}
              </div>

              <div className="input">
                <label
                  onClick={() => {
                    setIsEmojiShow(true);
                  }}
                  style={{ width: "23px" }}
                >
                  <img src={Smile} alt="" />
                </label>
                <input
                  type="file"
                  style={{ display: "none" }}
                  id="file"
                  accept=".xlsx,.xls,image/png,image/jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf,.mp4"
                  onChange={(e) => {
                    // setImg(e.target.files[0]);
                    uploadImg(e.target.files[0], client.msisdn);
                  }}
                />
                <label htmlFor="file" style={{ width: "23px" }}>
                  <img src={Attach} alt="" />
                </label>
                {/* <label
                  onClick={SpeechRecognition.startListening}
                  style={{ width: "23px" }}
                >
                  <img src={Mic} alt="" onClick={() => setText(transcript)} />
                </label> */}
                <input
                  type="text"
                  placeholder="Type something..."
                  onClick={() => {
                    setIsEmojiShow(false);
                  }}
                  onChange={(e) => textHandle(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSend(text, client.msisdn, "from");
                    }
                  }}
                  value={text}
                  id="messageTxt"
                />
                <div className="send">
                  <button
                    onClick={() => handleSend(text, client.msisdn, "from")}
                  >
                    <label style={{ width: "20px" }}>
                      <img src={Send} alt="" />
                    </label>
                    Send
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="chat">
              <div
                style={{
                  height: "85vh",
                  background: "#eff5ef",
                  marginTop: "10%",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h6>Select User</h6>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Chat;
